<template>
  <div class="">
    <router-link
      :to="{
        name: 'sendReport',
        query: {
          id: data.mode === 'company' ? data.companyId : data.branchId,
          accessLevel: data.mode === 'company' ? 'company' : 'branch',
          forward: 'false',
        },
      }"
      class="mr-2 btn btn-primary"
    >
      {{
        data.sent === "Sent"
          ? $t("text.clickButtons.resend")
          : $t("text.clickButtons.send")
      }}
    </router-link>
    <router-link
      :to="{
        name: 'sendReport',
        query: {
          id: data.mode === 'company' ? data.companyId : data.branchId,
          type: data.mode,
          forward: 'true',
          accessLevel: data.mode === 'company' ? 'company' : 'branch',
        },
      }"
      class="btn btn-info"
    >
      {{ $t("text.clickButtons.forward") }}
    </router-link>
  </div>
</template>

<script>
import configObject from "@/config";
import Jquery from "jquery";
let $ = Jquery;

export default {
  data() {
    return {
      data: {},
    };
  },
  mounted() {
    window.onclick = (event) => {
      if (!event.target.matches(".dropbtn")) {
        var dropdowns = document.getElementsByClassName("dropdown-content");
        var i;
        for (i = 0; i < dropdowns.length; i++) {
          var openDropdown = dropdowns[i];
          if (openDropdown.classList.contains("show")) {
            openDropdown.classList.remove("show");
          }
        }
      }
    };
  },
  methods: {
    dropdownOption() {
      this.$eventHub.$emit("showExtraCompanyButtons", this.data);
    },
    sendCompanyReport() {
      this.$eventHub.$emit("sendCompanyReportsModal", this.data);
    },
  },
};
</script>
